export const SHELL = `
<!-- LOGIN -->
<div id="login">
  <div class="login-card">
    <div class="login-mark" data-icon="recycle" data-size="30"></div>
    <h1>SSREC ERP</h1>
    <p class="sub">Welcome back — sign in to continue</p>
    <div class="login-err" id="loginErr"></div>
    <div class="field"><label>Username</label><input id="u" placeholder="Enter username" autocomplete="username"></div>
    <div class="field"><label>Password</label><input id="p" type="password" placeholder="Enter password" autocomplete="current-password"></div>
    <button class="btn-primary" onclick="doLogin()">Sign in</button>
      <p class="sub" style="margin-top:18px;line-height:1.7">Sign in with your <b>mobile</b> &amp; <b>password</b>.</p>
    </div>
</div>

<!-- APP -->
<div id="app" class="hidden">
  <aside class="sidebar" id="sidebar">
    <div class="brand"><span class="bmark" data-icon="recycle" data-size="24"></span>
      <span class="bt"><b>SSREC</b><span>RECYCLING ERP</span></span></div>
    <div class="menu-label">OVERVIEW</div>
    <nav class="nav" id="nav">
      <a data-route="dashboard" class="active"><span class="ico" data-icon="dashboard"></span> Dashboard</a>
      <a data-route="users" data-role="unofficial"><span class="ico" data-icon="users"></span> Users</a>
      <div class="menu-label" style="padding-top:8px" data-role="unofficial">OPERATIONS</div>
      <div class="group" id="opsGroup" data-role="unofficial">
        <button class="group-head" onclick="toggleOps()">
          <span style="display:flex;align-items:center;gap:13px"><span class="ico" data-icon="settings"></span> Operations</span>
          <span class="caret" data-icon="chevron" data-size="16"></span>
        </button>
        <div class="submenu">
          <a data-route="auto">Automatic Operations</a>
          <a data-route="manual-sha">Manual Operations (Shamshabad)</a>
          <a data-route="manual-thu">Manual Operations (Thumkunta)</a>
        </div>
      </div>
      <div class="menu-label" style="padding-top:8px">PLANTS</div>
      <a data-route="sha-plant"><span class="ico" data-icon="factory"></span> Shamshabad</a>
      <a data-route="thu-plant"><span class="ico" data-icon="factory"></span> Thumkunta</a>
    </nav>
  </aside>

  <div class="main">
    <header class="topbar">
      <div class="tb-left">
        <button class="hamb" onclick="document.getElementById('sidebar').classList.toggle('show')" data-icon="menu" data-size="22"></button>
        <span class="crumb" id="crumb">Dashboard</span>
      </div>
      <div class="topsearch"><svg class="ic-svg" viewBox="0 0 24 24" width="17" height="17"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg><input placeholder="Search operations, plants, users…"></div>
      <div class="tb-right">
        <span class="company" id="companyLbl"><b>SSREC Plants</b> · FY 2025‑26</span>
        <span class="rolepill unofficial" id="roleBadge">Unofficial</span>
        <button class="iconbtn" title="Fullscreen" onclick="toggleFs()" data-icon="maximize"></button>
        <button class="signout" onclick="logout()">Sign out</button>
      </div>
    </header>
    <div class="content" id="content"></div>
    <div class="foot"><span>2026 © Noris.</span><span>Design &amp; Develop by Noris</span></div>
  </div>
</div>

<div id="modalRoot"></div>
<div id="toast"><span class="dot" data-icon="check" data-size="16"></span><span id="toastMsg">Saved</span></div>
`;

export function renderShell(root='root'){
  document.getElementById(root).innerHTML = SHELL;
}
